import { ClientEventEmitter } from '../../marketing/ClientEventEmitter';
import { ClientEvents } from '../../constants/clientEvents';
import { sendPaymentMethodChosenFact, sendPaymentProceedFact } from '../../stat/factHelpers';
import { PaymentObject } from '../../types/payments';
import { GtmSender } from '../../marketing/GtmSender';
import { commerceEvents } from '../../constants/gameEvents';
import consoleLogger from '../../logger/consoleLogger';
import { WebGuestWarningPopup } from './webGuestWarningPopup';

const logger = consoleLogger.getPrefixedCopy('PAYMENT_EVENTS');

export type PaymentMethodChosenData = {
    paymentId: number,
    paymentMethod: string,
    paymentSubmethod: string
}

type PaymentTransactionCreatedData = { paymentId: number, paymentMethod: string, transactionId: number }

type PayFinishEventData = { paymentObject: PaymentObject };

function eventInitiateCheckoutHandler(_event: Event, data: PayFinishEventData) {
    GtmSender.fireFacebook(commerceEvents.INITIATE_CHECKOUT, data);
}

function eventPaymentFinishedHandler(_event: Event, data: PayFinishEventData) {
    GtmSender.fireFacebook(commerceEvents.GA_PURCHASE, data);
}

function handlePaymentMethodChosen(_event: Event, data: PaymentMethodChosenData) {
    sendPaymentMethodChosenFact(data.paymentId, data.paymentMethod, data.paymentSubmethod);
}

function handlerPaymentProceed(_event: Event, data: PaymentTransactionCreatedData) {
    sendPaymentProceedFact(data.paymentId, data.paymentMethod, data.transactionId);
}

type FirstBuyEventData = {
    pmObject: PaymentObject
};

function eventFirstBuyHandler(_event: Event, _data: FirstBuyEventData) {
    logger.info('app.eventFirstBuy');
    try {
        GtmSender.fireMarketing(commerceEvents.FIRST_PAYMENT);
    } catch (error) {
        window.Sentry.captureException(error);
    }
    logger.info('app.event1stpayment ::end');
}

async function eventSuccessBuyHandler(_event: Event, data: {
    amount: string
}) {
    logger.info('app.eventSuccessBuy');
    try {
        GtmSender.fireMarketing(
            commerceEvents.SUCCESS_BUY,
            {
                value: data.amount
            }
        );
        GtmSender.fireEcommerce(commerceEvents.PAYMENT_SUCCESS_FINISHED, parseFloat(data.amount));
    } catch (error) {
        window.Sentry.captureException(error);
    }
    logger.info('app.eventSuccessBuy::end');
}

function showAccountTetherWarning() {
    WebGuestWarningPopup.showWebGuestNotificationWindow();
}

export function setPaymentEventsListeners() {
    ClientEventEmitter.on<PayFinishEventData>(ClientEvents.INITIATE_CHECKOUT, eventInitiateCheckoutHandler);
    ClientEventEmitter.on<PayFinishEventData>(ClientEvents.PAYMENT_FINISHED, eventPaymentFinishedHandler);
    ClientEventEmitter.on<{ amount: string }>(ClientEvents.SUCCESS_BUY, eventSuccessBuyHandler);
    ClientEventEmitter.on(ClientEvents.SUCCESS_BUY, showAccountTetherWarning);
    ClientEventEmitter.on<FirstBuyEventData>(ClientEvents.FIRST_BUY, eventFirstBuyHandler);
    ClientEventEmitter.on<PaymentMethodChosenData>(ClientEvents.PAYMENT_METHOD_CHOSEN, handlePaymentMethodChosen);
    ClientEventEmitter.on<PaymentTransactionCreatedData>(ClientEvents.PAYMENT_PROCEED, handlerPaymentProceed);
}
